import React from "react";
import { Button, Grid, Typography, Box } from "@mui/material";
import materialSymbolsFemale from "./assets/materialSymbolsFemale.png";
import torsosFemaleMale from "./assets/torsosFemaleMale.png";
import roundNextPlan from "./assets/roundNextPlan.png";
import signFilled from "./assets/signFilled.png";
import imageSeven from "./assets/imageSeven.png";
import topArrow from "./assets/topArrow.png";
import infoBG from "./assets/infoBG.png";
import Vector from "./assets/Vector.png";
import survey from "./assets/survey.png";
import happyCouple from "./assets/happyCouple.png";
import scan from "./assets/scan.png";
import test from "./assets/test.png";
import whiteHeart from "./assets/whiteHeart.png";
import { List, ListItem, ListItemButton } from "@mui/material";
import WisdomLogo from "./assets/wisdomLogo.png";
import womenImage from "./assets/images/womenImage.png";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { ReactComponent as HomeIcon } from "./assets/home.svg";
import { ReactComponent as VectorIcon } from "./assets/Vector.svg";
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import FullLockupMaroon from "./assets/Maroon.jpg";
import helmsley from "./assets/helmsley.jpg";
import icahn from "./assets/icahn.jpg";


import { withTranslation } from 'react-i18next';
import { Trans } from 'react-i18next'; // 1. Import Trans

import Footer from './components/Footer';
import MobileDrawer from './components/MobileDrawer';
import WebAppHeader from "./components/WebAppHeader";


class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.msalInstance = props.msalInstance;
    this.state = {
      isLoaded: false,
      drawerOpen: false,
    };
  }

  handleSelectStaff = async () => {
    window.location.href =
      "https://wisdom-dev-app.azurewebsites.net/webstaff/build/index.html";
  };

  // componentDidMount() {
  //   this.setState({ isLoaded: true });
  // }

  componentDidMount() {
    this.setState({ isLoaded: true });
    
    // Check if we should scroll to Learn More section
    this.checkAndScrollToLearnMore();
  }

  changeLanguage = (lng) => {
    this.props.i18n.changeLanguage(lng);
  };

  checkAndScrollToLearnMore = () => {
    const shouldScrollToLearnMore = localStorage.getItem('scrollToLearnMore');
    console.log('Landing componentDidMount - scrollToLearnMore flag:', shouldScrollToLearnMore);
    
    if (shouldScrollToLearnMore === 'true') {
      console.log('Found scrollToLearnMore flag, clearing it and setting up scroll');
      // Clear the flag immediately
      localStorage.removeItem('scrollToLearnMore');
      
      // Use multiple attempts with different delays to ensure it works
      setTimeout(() => {
        console.log('First attempt - looking for learn-more section');
        this.scrollToLearnMore();
      }, 100);
      
      setTimeout(() => {
        console.log('Second attempt - looking for learn-more section');
        this.scrollToLearnMore();
      }, 500);
      
      setTimeout(() => {
        console.log('Third attempt - looking for learn-more section');
        this.scrollToLearnMore();
      }, 1000);
      
      setTimeout(() => {
        console.log('Final attempt - looking for learn-more section');
        this.scrollToLearnMore();
      }, 2000);
    }
  }

  scrollToLearnMore = () => {
    const learnMoreSection = document.querySelector('[data-section="learn-more"]');
    console.log('Found learn-more section:', learnMoreSection);
    if (learnMoreSection) {
      console.log('Scrolling to learn-more section');
      learnMoreSection.scrollIntoView({ behavior: 'smooth' });
      return true;
    } else {
      console.log('Learn-more section not found');
      return false;
    }
  }

  toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ drawerOpen: open });
  };



  handleSelectPart = () => {
    this.props.onClickGoToPage("Already registered");
  };

  handleSelectStaff = () => {
    window.location.href = 'https://wisdom-sandbox-webapp-hecrgdgtbgetb4ag.eastus-01.azurewebsites.net/webstaff/build/index.html';
  };

  handlVideoeOpen = () => {
    this.setState({ open: true });
  };

  handleVideoClose = () => {
    this.setState({ open: false });
  };

  handleOpenInNewTab = () => {
    window.open("https://www.youtube.com/watch?v=-iQEVX3GUdk", "_blank");
  };

  render() {
    const { drawerOpen } = this.state;
    const { t, i18n } = this.props;

    if (this.state.isLoaded) {
      return (
        <>
        <WebAppHeader 
            t={t}
            i18n={i18n}
            view={this.props.view}
            changeLanguage={this.changeLanguage}
            onClickGoToPage={this.props.onClickGoToPage}
            onOpenDrawer={this.toggleDrawer(true)}
            Logo={WisdomLogo}
            icons={{
              HomeIcon,
              InfoOutlinedIcon,
              GroupsOutlinedIcon,
              VectorIcon,
              PostAddOutlinedIcon
            }}
          />

        {/* Mobile Drawer */}
        <MobileDrawer 
            open={this.state.drawerOpen}
            onClose={this.toggleDrawer(false)}
            t={t}
            i18n={i18n}
            changeLanguage={this.changeLanguage}
            currentView={this.props.view}
            onClickGoToPage={this.props.onClickGoToPage}
            icons={{
              HomeIcon,
              InfoOutlinedIcon,
              GroupsOutlinedIcon,
              VectorIcon,
              PostAddOutlinedIcon
            }}
        />
                
          <Grid
             container
             sx={{
               padding: {
                 md: "0 0rem 0rem 5.3rem",
                 sm: "0 3rem 0rem 5.3rem",
                 xs: "0 20px 0px 20px",
               },
             }}
           >
             <Grid
               container
               sx={{
                 display: "flex",
                 justifyContent: "space-between",
                 alignItems: "flex-start",
                 paddingTop: { md: "90px", sm: "20px", xs: "20px" },
               }}
             >
               <Grid
                 item
                 xs={12}
                 md={8}
                 sx={{
                   display: "flex",
                   flexDirection: "column",
                   justifyContent: "center",
                   alignItems: "flex-start",
                   textAlign: "left",
                 }}
               >
                <Typography
                    sx={{
                      fontSize: { md: "46px", sm: "31px", xs: "25px" },
                      fontWeight: "600",
                      lineHeight: { md: "3.486rem", sm: "2.5rem", xs: "2rem" },
                    }}
                  >
                    <Trans
                      i18nKey="landing.title_start"
                      components={{
                        pink: <Box component="span" sx={{ color: "#D80C8C" }} />
                      }} 
                      />
                  
                  </Typography>
                 
                 <Typography
                   sx={{
                     padding: {
                       md: "3.5rem 0rem",
                       sm: "2.1rem 0rem",
                       xs: "1.25rem 0rem",
                     },
                     fontSize: { md: "24px", sm: "20px", xs: "16px" },
                     fontWeight: 400,
                   }}
                 >
                   {/* A Study Focused on Female Fertility and IBD */}
                    {t('landing.subtitle')}
                 </Typography>
                 
                <Button
                    sx={{
                      fontWeight: 700,
                      fontSize: { md: "20px", sm: "20px", xs: "16px" },
                      lineHeight: { md: "20px", sm: "20px", xs: "16px" },
                      letterSpacing: "0.5px",
                      color: "#FFFFFF",
                      backgroundColor: "#D80C8C",
                      padding: "16px",
                      borderRadius: "10px",
                      "&:hover": {
                        backgroundColor: "#D80C8C",
                      },
                      textTransform: "none",
                    }}
                    onClick={() => window.open("https://www.redcap.link/wisdomibdstudy", "_blank")}
                  >
                     {t('landing.get_started')}
                  </Button>
               </Grid>
               
               <Grid
                 item
                 xs={12}
                 md={3}
                 sx={{
                   display: { xs: "none", sm: "none", md: "flex" },
                   justifyContent: "flex-end",
                   alignItems: "center",
                   paddingTop: { md: "0px", sm: "0px", xs: "0px" },
                 }}
               >
                 <Box
                   sx={{
                     display: "flex",
                     justifyContent: "flex-end",
                     alignItems: "flex-start",
                     paddingBottom: "65px",
                     paddingRight: "45px",
                   }}
                 >
                   <img
                     alt="Pregnant Woman"
                     src={womenImage}
                     style={{
                       width: "150px",
                       height: "auto",
                       maxWidth: "100%",
                       paddingRight: "50px",
                       paddingBottom: "30px",
                     }}
                   />
                 </Box>
               </Grid>
             </Grid>
           </Grid>

          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: {
                md: "5.5rem 2.3rem 8.3rem 2.3rem",
                sm: "5rem 1.3rem 4rem 1.3rem",
                xs: "4.5rem 0.5rem 2.3rem 0.5rem",
              },
            }}
          >
            <Box
              sx={{
                borderRadius: "4rem",
                background:
                  "linear-gradient(270deg, #A20969, #D80C8C, #221F73, #1B195C, #AD0A70, #C20B7E)",
                maxWidth: "50.6rem",
                width: { md: "70%", sm: "70%", xs: "80%" },
                height: { md: "15px", sm: "15px", xs: "6px" },
              }}
            ></Box>
          </Grid>

          <Grid
            sx={{
              textAlign: "center",
              padding: {
                md: "0rem 2.3rem  5.1rem 2.3rem",
                sm: "0rem 2.3rem  3.5rem 2.3rem",
                xs: "0px 15px  30px 15px",
              },
            }}
            data-section="learn-more"
          >
            <Typography
              sx={{
                fontSize: { md: "2.8rem", sm: "2.5rem", xs: "30px" },
                fontWeight: 600,
                color: "#000000",
              }}
            >
              {/* Learn More */}
                {t('landing.learn_more')}
              
            </Typography>
            <Typography
              sx={{
                fontSize: { md: "18px", sm: "18px", xs: "15px" },
                fontWeight: 400,
                color: "#000000",
              }}
            >
             {t('landing.our_study')} 
             
            </Typography>
          </Grid>

          <Grid
            container
            sx={{
              padding: {
                md: "0 6.28rem 0 4.06rem",
                sm: "0 3rem 0 3rem",
                xs: "0 10px 0 10px",
              },
              margin: "0px !important",
            }}
          >
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Grid sx={{ textAlign: { md: "left", xs: "center" } }}>
                <img
                  src={happyCouple}
                  alt="Happy Couple"
                  style={{
                    maxWidth: "327px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
              </Grid>

              <Grid
                sx={{
                  textAlign: "center",
                  display: {
                    xs: "none",
                    md: "block",
                  },
                }}
              >
                <img
                  src={scan}
                  alt="icons"
                  style={{
                    maxWidth: "327px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
              </Grid>

              <Grid
                sx={{
                  display: {
                    xs: "none",
                    md: "block",
                  },
                }}
              >
                <img
                  src={test}
                  alt="icons"
                  style={{
                    maxWidth: "327px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: { md: "25px", sm: "15px", xs: "15px" },
              }}
            >
              <Grid
                container
                direction="column"
                sx={{ width: "100%", margin: "0px !important" }}
                spacing={6}
              >
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "0px !important",
                  }}
                >
                  <Box
                    sx={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                      backgroundColor: "#221F73",
                      borderRadius: "10px",
                    }}
                  >
                    <img
                      src={imageSeven}
                      style={{ width: "24px", height: "24px" }}
                      alt="Icon"
                    />
                  </Box>
                  <Typography
                    sx={{
                      marginLeft: "1rem",
                      color: "#000",
                      fontWeight: 500,
                      fontSize: { md: "18px", xs: "14px" },
                    }}
                  >
                    {/* This research study is an opportunity to help understand the
                    impact of Inflammatory Bowel Disease (IBD) on fertility. */}
                     {t('landing.opportunity')}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "0px !important",
                  }}
                >
                  <Box
                    sx={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                      backgroundColor: "#221F73",
                      borderRadius: "10px",
                    }}
                  >
                    <img
                      src={imageSeven}
                      style={{ width: "24px", height: "24px" }}
                      alt="Icon"
                    />
                  </Box>
                  <Typography
                    sx={{
                      marginLeft: "1rem",
                      color: "#000",
                      fontWeight: 500,
                      fontSize: { md: "18px", xs: "14px" },
                    }}
                  >
                    {/* Approximately 50% of patients with Crohn's disease or
                    ulcerative colitis are women, and many are diagnosed during
                    peak childbearing years. */}
                    {t('landing.crohns')}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",

                    paddingLeft: "0px !important",
                  }}
                >
                  <Box
                    sx={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                      backgroundColor: "#221F73",
                      borderRadius: "10px",
                    }}
                  >
                    <img
                      src={imageSeven}
                      style={{ width: "24px", height: "24px" }}
                      alt="Icon"
                    />
                  </Box>
                  <Typography
                    sx={{
                      marginLeft: "1rem",
                      color: "#000",
                      fontWeight: 500,
                      fontSize: { md: "18px", xs: "14px" },
                    }}
                  >
                    {/* Both patients and providers frequently ask whether IBD, IBD
                    surgery, or IBD medications impact a woman's ability to
                    become pregnant. Despite many advances in the field, several
                    important questions remain unanswered. */}
                      {t('landing.woman_ability')}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",

                    paddingLeft: "0px !important",
                  }}
                >
                  <Box
                    sx={{
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                      backgroundColor: "#221F73",
                      borderRadius: "10px",
                    }}
                  >
                    <img
                      src={imageSeven}
                      style={{ width: "24px", height: "24px" }}
                      alt="Icon"
                    />
                  </Box>
                  <Typography
                    sx={{
                      marginLeft: "1rem",
                      color: "#000",
                      fontWeight: 500,
                      fontSize: { md: "18px", xs: "14px" },
                    }}
                  >
                    {/* The results of this study will help to answer these
                    questions and provide essential information to IBD patients
                    and their care teams in order to ensure that patients are
                    supported during their journey to motherhood. If you have
                    IBD, you may be eligible to join. */}
                    {t('landing.study_results')}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: {
                md: "8.3rem 0rem 6.8rem 0rem",
                sm: "3.8rem 0rem 5rem 0rem",
                xs: "2.8rem 0rem 4rem 0rem",
              },
            }}
          >
            <Box
              sx={{
                borderRadius: "4rem",
                background:
                  "linear-gradient(270deg, #A20969, #D80C8C, #221F73, #1B195C, #AD0A70, #C20B7E)",
                maxWidth: "50.6rem",
                width: "70%",
                height: "15px",
              }}
            ></Box>
          </Grid>

          <Grid
            container
            spacing={2}
            sx={{
              padding: {
                md: "0 6.87rem 5.62rem 6.87rem",
                xs: "0px 10px 40px 25px",
                sm: "0px 20px 50px 45px",
              },
            }}
          >
            <Grid
              xs={12}
              sx={{
                textAlign: "center",
                padding: {
                  md: "0rem 0rem 4rem 0rem",
                  xs: "0rem 0rem 1rem 0rem",
                  sm: "0rem 0rem 1.5rem 0rem",
                },
              }}
            >
              <Typography
                sx={{
                  padding: "0rem",
                  fontSize: { md: "46px", sm: "35px", xs: "25px" },
                  fontWeight: 600,
                  lineHeight: { md: "56px", sm: "40px", xs: "30px" },
                }}
              >
                {/* Who Can Participate in WIsDoM ? */}
                   {t('landing.participate')}
              </Typography>
            </Grid>
            <Grid
              container
              spacing={2}
              sx={{
                paddingBottom: { md: "4rem", sm: "3rem", xs: "1.5rem" },
              }}
            >
          <Grid item xs={6} sm={6} md={3} sx={{ textAlign: "center" }}>
                 <Box
                   sx={{
                     backgroundColor: "#FCE4EC",
                     borderRadius: "15px",
                     padding: "20px",
                     height: "100%",
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                   }}
                 >
                   <img
                     alt="Female Symbol"
                     src={materialSymbolsFemale}
                     style={{
                       width: "48px",
                       height: "48px",
                       paddingBottom: "1rem",
                     }}
                   />
                   <Typography
                     sx={{
                       fontWeight: 400,
                       fontSize: { md: "18px", xs: "14px", sm: "16px" },
                       lineHeight: { md: "25px", xs: "20px", sm: "20px" },
                       textAlign: "center",
                     }}
                   >
                     {/* Women with Inflammatory Bowel Disease (IBD)  */}
                     {t('landing.women_ibd')}
                   </Typography>
                 </Box>
               </Grid>
               
               <Grid
                 item
                 xs={6}
                 sm={6}
                 md={3}
                 sx={{
                   textAlign: "center",
                 }}
               >
                 <Box
                   sx={{
                     backgroundColor: "#FCE4EC",
                     borderRadius: "15px",
                     padding: "20px",
                     height: "100%",
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                   }}
                 >
                   <img
                     alt="Male-Female Symbol"
                     src={torsosFemaleMale}
                     style={{
                       width: "48px",
                       height: "48px",
                       paddingBottom: "2rem",
                     }}
                   />
                   <Typography
                     sx={{
                       fontWeight: 400,
                       fontSize: { md: "18px", xs: "14px", sm: "16px" },
                       lineHeight: { md: "25px", xs: "20px", sm: "20px" },
                       textAlign: "center",
                       
                     }}
                   >
                    {/* Age 18-45 years   */}
                    {t('landing.age')}
                   </Typography>
                 </Box>
               </Grid>
               <Grid
                 item
                 xs={6}
                 sm={6}
                 md={3}
                 sx={{
                   textAlign: "center",
                 }}
               >
                 <Box
                   sx={{
                     backgroundColor: "#FCE4EC",
                     borderRadius: "15px",
                     padding: "20px",
                     height: "100%",
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                   }}
                 >
                   <img
                     alt="icons"
                     src={roundNextPlan}
                     style={{
                       width: "48px",
                       height: "48px",
                       paddingBottom: "1rem",
                     }}
                   />
                   <Typography
                     sx={{
                       fontWeight: 400,
                       fontSize: { md: "18px", xs: "14px", sm: "16px" },
                       lineHeight: { md: "25px", xs: "20px", sm: "20px" },
                       textAlign: "center",
                     }}
                   >
                     {/* Planning to become pregnant in the next 15 months  */}
                     {t('landing.planning')}
                   </Typography>
                 </Box>
               </Grid>
                             <Grid
                 item
                 xs={6}
                 sm={6}
                 md={3}
                 sx={{
                   textAlign: "center",
                 }}
               >
                 <Box
                   sx={{
                     backgroundColor: "#FCE4EC",
                     borderRadius: "15px",
                     padding: "20px",
                     height: "100%",
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                   }}
                 >
                   <img
                     alt="icons"
                     src={signFilled}
                     style={{
                       width: "48px",
                       height: "48px",
                       paddingBottom: "1rem",
                     }}
                   />
                   <Typography
                     sx={{
                       fontWeight: 400,
                       fontSize: { md: "18px", xs: "14px", sm: "16px" },
                       lineHeight: { md: "25px", xs: "20px", sm: "20px" },
                       textAlign: "center",
                     }}
                   >
                     {/* Able to consent to participate  */}
                     {t('landing.consent')}
                   </Typography>
                 </Box>
               </Grid>
            </Grid>

            <Grid xs={12} sx={{ textAlign: "center" }}>
               <Button
                 sx={{
                   fontWeight: 500,
                   fontSize: "20px",
                   lineHeight: "20px",
                   letterSpacing: "0.5px",
                   color: "#FFFFFF",
                   backgroundColor: "#D80C8C",
                   padding: "16px",
                   borderRadius: "10px",
                   textTransform: "none",
                   "&:hover": {
                     backgroundColor: "#D80C8C",
                   },
                 }}
                 onClick={() => window.open("https://www.redcap.link/wisdomibdstudy", "_blank")}
               >
                 {t('landing.get_started')}
               </Button>
             </Grid>
          </Grid>

          <Grid
            spacing={2}
            sx={{
              padding: {
                md: "0 6.87rem 5.62rem 6.87rem",
                xs: "0px 15px 40px 15px",
                sm: "0px 40px 50px 40px",
              },
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              sx={{
                height: { md: "450px", sm: "400px", xs: "300px" },
                width: { md: "60%", sm: "90%", xs: "90%" },
                display: "flex",
                justifyContent: "center",
              }}
            >
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/-iQEVX3GUdk"
                title="WisDoM"
                frameBorder="1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  borderRadius: "25px",
                  borderColor: "black"
                }}
              ></iframe>
            </Grid>
          </Grid>

          <Grid
            sx={{
              padding: { md: "0px 36px", sm: "0px 36px", xs: "0px 20px" },
            }}
          >
            <Grid
              sx={{
                backgroundImage: `url(${infoBG})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                padding: {
                  md: "77px 0px 27px 0px",
                  sm: "50px 0px 25px 0px",
                  xs: "18px 15px",
                },
              }}
            >
              <Grid sx={{ textAlign: "center" }}>
                <Typography
                  sx={{
                    color: "#221F73",
                    fontSize: { md: "20px", sm: "20px", xs: "18px" },
                    fontWeight: 700,
                    paddingBottom: { md: "21px", sm: "10px", xs: "21px" },
                  }}
                >
                  {/* INFORMATION */}
                  {t('landing.information')}
                </Typography>
                <Typography
                  sx={{
                    color: "#FFF",
                    fontSize: { md: "46px", sm: "36px", xs: "25px" },
                    fontWeight: 600,
                  }}
                >
                  {/* What Participation Involves */}
                  {t('landing.participation')}
                </Typography>
              </Grid>

              <Grid
                direction={{ xs: "column", sm: "row" }}
                sx={{
                  padding: { md: "80px", sm: "20px 40px", xs: "25px 0px" },
                  display: "flex",
                  gap: "16px",
                }}
              >
                <Box
                  sx={{
                    padding: { md: "24px", sm: "15px", xs: "10px" },
                    borderRadius: "20px",
                    width: "100%",
                    background: "white",
                    textAlign: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={Vector}
                      alt="Icon"
                      style={{ width: "32px", height: "32px" }}
                    />
                    <Typography
                      sx={{
                        color: "#221F73",
                        paddingBottom: "8px",
                        fontSize: { md: "24px", sm: "24px", xs: "18px" },
                        fontWeight: 700,
                        marginLeft: "8px",
                      }}
                    >
                     {t('landing.getting_started')}
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      color: "#21272A",
                      paddingBottom: { md: "35px", sm: "25px" },
                      fontSize: { md: "18px", sm: "18px", xs: "14px" },
                      fontWeight: 400,
                      paddingTop: { md: "20px", sm: "10px" },
                    }}
                  >
                    {/* Once consent is obtained, you will be asked to complete an
                    initial survey, and the research team will contact you to
                    collect information about your IBD history. */}
                    {t('landing.consent_obtained')}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    padding: { md: "24px", sm: "15px", xs: "10px" },

                    borderRadius: "20px",
                    width: "100%",
                    background: "white",
                    textAlign: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={survey}
                      alt="survey"
                      style={{ width: "22px", height: "32px" }}
                    />
                    <Typography
                      sx={{
                        color: "#221F73",
                        paddingBottom: { md: "8px", sm: "8px", xs: "5px" },
                        fontSize: { md: "24px", sm: "24px", xs: "18px" },
                        fontWeight: 700,
                        marginLeft: "8px",
                      }}
                    >
                      {/* Surveys */}
                      {t('landing.surveys')}
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      color: "#21272A",
                      paddingBottom: { md: "35px", sm: "25px" },
                      fontSize: { md: "18px", sm: "18px", xs: "14px" },
                      fontWeight: 400,
                      paddingTop: { md: "20px", sm: "10px" },
                    }}
                  >
                    {/* You will then be asked to complete monthly surveys while trying to conceive and for an additional three months after becoming pregnant. You may choose to opt out of the study at any time. */}
                    {t('landing.survey_detail')}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            sx={{
              padding: {
                md: "3.18rem 2.37rem 0.87rem 2.31rem",
                xs: "39px 24px 24px 24px",
                sm: "39px 44px 24px 44px",
              },
            }}
          >
            <Grid>
              <Grid
                container
                spacing={2}
                sx={{
                  paddingTop: "2.5rem",
                  paddingBottom: { md: "4rem", xs: "2rem", sm: "3rem" },
                  paddingLeft: { xs: "0px", md: "5rem" },
                  paddingRight: { xs: "0px", md: "5rem" },
                }}
              >
                <Grid item xs={12} sm={12} md={4} sx={{ textAlign: "center" }}>
                  <img
                    alt="icon"
                    src={icahn}
                    style={{
                      width: "250px",
                      height: "auto",
                      paddingBottom: "1rem",
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4} sx={{ textAlign: "center" }}>
                  <img
                    alt="icon"
                    src={helmsley}
                    style={{
                      width: "250px",
                      height: "auto",
                      paddingBottom: "1rem",
                    }}
                  />
                </Grid>

                <Grid xs={12} sm={12} md={4} sx={{ textAlign: "center" }}>
                  <img
                    alt="icon"
                    src={FullLockupMaroon}
                    style={{
                      width: "240px",
                      height: "auto",
                      paddingBottom: "1rem",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Footer */}
          {/* Inside your render return, at the bottom */}
          <Footer 
            t={t} 
            onClickGoToPage={this.props.onClickGoToPage} 
            whiteHeart={whiteHeart} 
            topArrow={topArrow} 
          />
      
        </>
      );
    } else {
      return <div>Loading...</div>;
    }
  }
}

// Wrap with withTranslation HOC
export default withTranslation()(Landing);
